module.exports = __webpack_public_path__ + "img/flow1.701e7492.png";